import { render, staticRenderFns } from "./modalSure.vue?vue&type=template&id=27ca33f8&"
import script from "./modalSure.vue?vue&type=script&lang=js&"
export * from "./modalSure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports